import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { PoweredBy } from "@/components/Footer";
import { Logo } from "@/components/Logo";

const FollowAction = ({ kind }) => {
  const { t } = useI18n();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [res, setRes] = useState(null);
  const done = useRef(false);
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    if (token.length < 20) { setRes({ ok: false }); return; }
    api.post(`/follow/${kind}`, { token }).then((r) => setRes({ ok: true, ...r.data }))
      .catch((e) => setRes({ ok: false, status: e?.response?.status, msg: formatApiError(e) }));
  }, [kind, token]);
  return (
    <div className="relative min-h-screen bg-[#04050a] grid place-items-center px-5" data-testid={`follow-${kind}-page`}>
      <PoweredBy />
      <div className="cx-card cx-brackets rounded-3xl p-8 max-w-md w-full text-center">
        <div className="flex justify-center mb-6"><Logo /></div>
        {!res && <Loader2 className="w-8 h-8 animate-spin text-[#3ad7ff] mx-auto" />}
        {res?.ok && (<>
          <CheckCircle2 className="w-10 h-10 text-[#22e3a1] mx-auto" />
          <p className="text-white mt-4" data-testid={`follow-${kind}-ok`}>
            {kind === "confirm" ? t("fl.confirmed").replace("{name}", res.creator || "") : t("fl.unsubscribed")}
          </p>
          {kind === "confirm" && res.handle && <Link to={`/u/${res.handle}`} className="cx-btn rounded-full px-6 py-2.5 inline-block mt-6 text-sm font-semibold" data-testid="follow-profile-link">{t("pf.view_creator")}</Link>}
        </>)}
        {res && !res.ok && (<>
          <XCircle className="w-10 h-10 text-rose-400 mx-auto" />
          <p className="text-slate-300 mt-4" data-testid={`follow-${kind}-error`}>{!res.status || res.status === 400 || res.status === 422 ? t("fl.invalid_link") : res.msg}</p>
        </>)}
        <Link to="/vitrine" className="block text-sm text-[#3ad7ff] mt-6">{t("vt.see_all")}</Link>
      </div>
    </div>
  );
};

export const FollowConfirm = () => <FollowAction kind="confirm" />;
export const FollowUnsubscribe = () => <FollowAction kind="unsubscribe" />;
